import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { SnackBarItem } from '../snack-bar/snack-bar-item';

@Component({
  selector: 'app-add-new-location',
  templateUrl: './add-new-location.component.html',
  styleUrls: ['./add-new-location.component.scss']
})
export class AddNewLocationComponent extends BaseClass implements OnInit, OnDestroy {
  public form: FormGroup;
  public isFormChange: boolean = false;
  public submited: boolean = false;
  public showDigitsError: boolean = false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddNewLocationComponent>,
    private layoutService: LayoutService,
  ) { super() }

  ngOnInit(): void {
    this.form = this.fb.group({
      location: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]]
    });

    this.attachSubscriptions(
      this.form.valueChanges.subscribe(() => this.isFormChange = true)
    );

    this.attachSubscriptions(
      this.dialogRef.backdropClick().subscribe(e => {
        e.preventDefault();
        if (this.isFormChange) {
          this.layoutService.openBottomSheet(this.dialogRef);
        } else {
          this.close();
        }
      })
    );
  }

  checkDigits() {
    const value = this.form.get('location')?.value;
    this.showDigitsError = value && !/^[0-9]+$/.test(value);
  }

  close() {
    this.dialogRef.close({event: "close", data: false});
  }

  submitForm() {
    this.submited = true;
    this.checkDigits(); // Проверяем перед отправкой
    
    if (this.form.invalid || this.showDigitsError) {
      if (this.showDigitsError) {
        this.layoutService.showSnackBar(
          {name: 'Invalid value'}, 
          "Value must contain only digits", 
          SnackBarItem
        );
      }
      return;
    } 
    
    this.submited = false;
    this.dialogRef.close({event: "close", data: this.form.value.location});
  }

  ngOnDestroy(): void {
    this.clearSubscriptions();
  }
}
